// extracted by mini-css-extract-plugin
export var growableInput = "_3f-0";
export var tagContainer = "_3f-2";
export var textInput = "_3f-1";